import * as React from "react";

interface PanelTabContentProps {
  children?: React.ReactNode;
  index: number;
  activePanelIndex: number;
  id?: string;
}
function PanelTabContent(props: PanelTabContentProps) {
  const { children, id = "", activePanelIndex, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={activePanelIndex !== index}
      id={`${id}-tabpanel-${index}`}
      aria-labelledby={`${id}-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

export default PanelTabContent;
